import { render, staticRenderFns } from "./RSearchNewFoundsAlertCard.vue?vue&type=template&id=36a6ad96&scoped=true&"
import script from "./RSearchNewFoundsAlertCard.vue?vue&type=script&lang=js&"
export * from "./RSearchNewFoundsAlertCard.vue?vue&type=script&lang=js&"
import style0 from "./RSearchNewFoundsAlertCard.vue?vue&type=style&index=0&id=36a6ad96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a6ad96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDivider,VIcon})
